<template>
  <div>
    <Header></Header>
    <div class="container-l">
        <div class="sub-title" ref='title1'>
            <img src="~pic/forum/thesis.png">
            <p>论文征集</p>
        </div>
        <div class="list">
            <div v-for="(item,index) in paper" :key="index">
                <p class="index">{{index+1}}</p>
                <div class="title">
                    <p>{{item.title}}</p>
                    <p>{{deal(item.author)}}</p>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import header from "../components/Headers/header2";
import footer from "../components/footer";
import { getForum } from '../service'
export default {
    components:{
      Header: header,
      Footer: footer
    },
    data(){
      return {
        paper: []
      }
    },
    methods:{
        async getForum() {
            let res = await getForum({activity_id: this.$store.state.activity_id}, (error) => {this.$Message.error('请求错误')})
            if (res.status == 'success') {
                this.paper = res.paper
            }
        },
        deal(author) {
            if(!author) {
                return '--'
            }
            return JSON.parse(author).map(item => item.name).join(',')
        }
    },
    created(){
      this.getForum()
    }
}
</script>

<style lang="stylus" scoped>
.container-l
    padding-top: 1.18rem;
    .sub-title
        font-weight: bold;
        color: #333;
        font-size: .48rem;
        position: relative;
        margin: 0 auto;
        margin-bottom: .7rem;
        img
            height: .6rem;
            width: auto;
            display: block;
            margin: 0 auto;
        p
            position: absolute;
            text-align: center;
            left: 0;
            bottom: -.34rem;
            width: 100%;
    .list
        padding 0 .32rem .32rem
        >div
            display flex
            align-items center
            min-height 1.72rem
            &:nth-child(2n-1)
                background: rgba(225, 34, 34, 0.05)
            .title,.index
                padding .26rem .32rem
            .index
                color #E12222
                font-size .4rem
                text-align center
                max-width 1.2rem
                min-width 1.2rem
            .title
                display flex
                flex-direction column
                justify-items center
                p:nth-child(1)
                    color #333333
                    font-size .28rem
                    line-height .4rem
                p:nth-child(2)
                    color #999999
                    font-size .24rem
                    margin-top .08rem
</style>
